import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import teamService from "../../Services/TeamService";
const TeamInfo = () => {
  const { teamId } = useParams();
  console.log(teamId);
  const [name, setName] = useState("");
  const [teamData, setTeamData] = useState("");

  const navigate = useNavigate();
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const handleBack = () => {
    if(userRole === "Admin"){

      navigate("/admin/sale-team");
    }else if(userRole === "CMO"){
      navigate("/cmo/sale-team");

    }
  };
  useEffect(() => {
    (async () => {
      const teamResponse = await teamService.getTeamData(teamId)
      const teamData = teamResponse.data;
      console.log(teamData);
      setTeamData(teamData);
    })();
  }, [teamId]);

  return (
    <div className="pt-20 mt-1 h-screen w-full bg-appGrayBackground">
      <AdminAppBar />
      <div className="bg-appGrayBackground">
        <div>
          <svg
            onClick={handleBack}
            className="cursor-pointer absolute 3xl:inset-x-32 lg:inset-y-32 lg:inset-x-24 md:inset-x-14 md:inset-y-28 md:w-5 md:h-7 lg:w-5 lg:h-9"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
        </div>

        <div className="lg:mx-36 md:mx-24 lg:py-2 md:py-0 lg:pb-6 md:pb-14">
          <div className="flex justify-between pt-8">
            <div className="font-semibold md:mx-0 3xl:ml-12 lg:mx-0 md:text-2xl lg:text-4xl">
              Team Information
            </div>
          </div>
          <form className="bg-white shadow-md rounded 3xl:w-12/12 3xl:mx-14 md:px-4 lg:px-8 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="name"
              >
                Name
              </label>
              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData.name}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="lead-source"
              >
                BOD
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData?.BOD?.map((obj) => obj.name).join(", ")}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="lead-source"
              >
                MD
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData.MD?.name}
                readOnly
              />
            </div>

            <div className="mb-8 flex items-center">
              <label
                className="w-1/4 text-gray-700 text-2xl font-medium"
                htmlFor="members"
              >
                Members
              </label>

              <input
                className="shadow appearance-none border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                value={teamData?.members?.map((obj) => obj.name).join(", ")}
                readOnly
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TeamInfo;
